export type TurnstileVerifyResponse = {
  success?: boolean;
  message?: string;
};

export async function verifyTurnstileToken(token: string): Promise<boolean> {
  if (!token) return false;
  try {
    const res = await fetch("/api/turnstile/verify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    if (!res.ok) return false;
    const data = (await res.json()) as TurnstileVerifyResponse;
    return data?.success === true;
  } catch {
    return false;
  }
}
